var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { WorkspacesKeyFactory } from '../../query-key-factories';
export const useDeclineInvitation = (workspaceId, { onError, onSuccess } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: () => lucidSdk.currentUserManagement().declineInvitation(workspaceId),
        onSuccess: async () => {
            try {
                await queryClient.refetchQueries({
                    exact: true,
                    queryKey: WorkspacesKeyFactory.all(),
                });
            }
            finally {
                if (typeof onSuccess === 'function') {
                    await onSuccess();
                }
            }
        },
        onError: (error) => {
            try {
                if (typeof onError === 'function') {
                    onError(error);
                }
            }
            finally {
                // Self-heal: a failed decline usually means the membership
                // changed remotely — refetch, without blocking the mutation
                // settling, so the UI stops offering a stale action
                void queryClient.refetchQueries({
                    exact: true,
                    queryKey: WorkspacesKeyFactory.all(),
                });
            }
        },
        networkMode: 'always',
    });
    return { mutation };
};
_react_refresh_temp_1(useDeclineInvitation, "s074ag8lSG2K0z8InO7Yl75Raxc=", false, () => [useLucidSdk, useQueryClient, useMutation]);
